import { IonButton, IonList } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NormalText, Spacer, StrongText } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { SubscriptionLine } from '../../components/subscription-item';
import { withTranslation } from '../../lib/translate';
import { forwardTo, go, isWebConfig } from '../../lib/utils';
import { setSelectedSubscription } from '../../store/orders/actions';
import { getSubscriptions } from '../../store/subscription/actions';
import './index.css';
import Modal from '../../components/modal';
const handleMembership = () => forwardTo('/membership-terms');
import Mobiscroll from '../../components/mobiscroll';
import FieldWrapper from '../../components/fieldWrapper';
import { getConfig } from '../../appConfig';

const { SelectOption } = Mobiscroll;

const ChooseSubscription = ({ __, subscriptions, selectedSubscription, activeSubscription, getSubscriptions, setSelectedSubscription, clientProfile, location, history, restaurants }) => {
  useEffect(() => {
    getSubscriptions();
  }, []);
  const [selectedStore, setSelectedStore] = useState(null)
  const [subscription, setSubscription] = useState(null)

  const [selectedStoreModalOpen, setSelectedStoreModal] = useState(false)

  if (activeSubscription && subscriptions.find((subscription) => subscription.id === activeSubscription.id)) {
    forwardTo('/my-membership');
  }

  let imageUrl = null;
  const items = subscriptions.map((e, idx) => {
    const isChecked = idx === selectedSubscription?.idx;
    if (imageUrl === null) {
      imageUrl = e.image;
    }
    const price = e.monthly_cost_inc_vat / 100;
    return SubscriptionLine(
      __,
      () => {
        if (getConfig().flags.hasMembershipStore) {
          setSubscription({ id: e.id, idx })
          setSelectedStoreModal(true)
        } else {
          setSelectedSubscription({ id: e.id, idx });
          handleMembership();
        }

      },
      idx,
      isChecked,
      e.name,
      e.short_description,
      price,
      e.perks,
    );
  });

  const fromChooseSubscriptionMenu = location?.state?.fromChooseSubscriptionMenu;
  const backHandler = () => {
    fromChooseSubscriptionMenu ? go(-2) : history.goBack();
  };
  return (
    <Loading transparent>
      <Layout
        showHamburger
        color="transparent"
        scrollY={false}
        headerTitle={__('MembershipChooser')}
        hideSecondToolbar={true}
        backHandler={backHandler}
      >
        <div className="absolute-content scrollable-y">
          <StrongText  >{__('Available subscription packages')}</StrongText>
          <Spacer size={2} />
          <div className="subscription-list">
            {items}

          </div>
        </div>
        {getConfig().flags.hasMembershipStore &&
          <Modal
            isOpen={selectedStoreModalOpen}
            className='modal-type-alert'
            onDidDismiss={() => setSelectedStoreModal(false)}

          >
            <div className="input-field-container">
              <StrongText className="primary-color">{__('Chose home store')}</StrongText>
              <FieldWrapper dropdown>
                <SelectOption
                  theme='ios'
                  cssClass={isWebConfig() ? 'web' : ''}
                  display="center"
                  onSet={(event, data) => setSelectedStore(data.getVal())}
                  data={[{ value: '', text: '' }, ...restaurants.filter(el=>el.is_published).map(el => ({ value: el.id, text: el.name }))]}
                  label="Location"
                  value={selectedStore}
                  inputStyle="box"
                  placeholder={__('Select store')}
                  cancelText={__('Cancel')}
                  setText={__('OK')}
                />
              </FieldWrapper>

            </div>
            <div className='alert-button-group'>
              <IonButton
                onClick={() => setSelectedStoreModal(false)}
                fill='outline'
                expand="block"
                className="submit-button"
              >
                {__('Cancel')}
              </IonButton>
              <IonButton
                color="primary"
                expand="block"
                onClick={() => {
                  setSelectedSubscription({ ...subscription, homeLocationId:selectedStore })
                  handleMembership()
                }}

              >
                {__('Done')}
              </IonButton>
            </div>
          </Modal>
        }

      </Layout>
    </Loading>
  );
};

const mapStateToProps = (store) => ({
  subscriptions: store.subscription.subscriptions,
  selectedSubscription: store.orders.selectedSubscription,
  activeSubscription: store.profile.profile.active_subscription,
  clientProfile: store.common.clientProfile,
  restaurants: store.restaurants.restaurants
});

const mapDispatchToProps = {
  setSelectedSubscription,
  getSubscriptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(ChooseSubscription));
